import React, { useMemo } from 'react'
import { actionAtom } from 'atoms/atoms'
import { useAtomValue } from 'jotai'
import { Sheet } from '@node-space/ui-components'
import { ActionIds } from 'types/types'
import { MerchantDetails } from './MerchantDetails'
import { MerchantForm } from './MerchantForm'

interface MerchantSheetProps {
  isSheetOpen: boolean
}

export const MerchantSheet = ({ isSheetOpen }: MerchantSheetProps) => {
  const action = useAtomValue(actionAtom)
  const { onBack, onClose, header, subHeader } = action || {}

  const sheetContent = useMemo(() => {
    switch (action?.actionId) {
      case ActionIds.MERCHANT_CREATE:
        return <MerchantForm action="CREATE" />
      case ActionIds.MERCHANT_EDIT:
        return <MerchantForm action="EDIT" />
      case ActionIds.MERCHANT_DETAILS:
        return <MerchantDetails />
      default:
        return null
    }
  }, [action])

  return (
    <Sheet
      header={header}
      onBack={onBack}
      isOpen={isSheetOpen}
      onClose={onClose}
      subHeader={subHeader}
    >
      {sheetContent}
    </Sheet>
  )
}
